import { Lookup } from "@data-types";
import { OccupationGroupDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformTitlesApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/occupation-groups`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findOccupationGroups(): Promise<
		Lookup<OccupationGroupDataType>
	> {
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}/?rpp=1000&translate=true`,
				this.getRequestHeaders()
			)
		);

		return response;
	}
}

export default PlatformTitlesApiService;
